<template>
    <div
        class="h-6 pl-2 pr-3 py-1 bg-white rounded-full border border-slate-200 justify-start items-center gap-2 flex text-slate-800"
    >
        <span class="flex items-center justify-start gap-1">
            <Icon :icon="badge.icon" />
            <div class="text-xs font-medium leading-none">
                {{ badge.status }}
            </div>
        </span>
        <!-- START ICON AND # OF MATCHES -->
        <div
            class="w-px h-3 bg-zinc-300"
            v-show="alert.status === 'found'"
        ></div>
        <div
            class="justify-start items-center gap-1 pl-0.5 flex relative"
            v-if="alert.status === 'found'"
        >
            <!-- RED DOT IF NEW SINCE USER LAST LOGGED IN -->
            <div
                class="w-3 h-3 bg-orange-600 rounded-full border-2 border-white absolute -top-0.5 -left-0.5"
            ></div>
            <!-- END RED DOT -->

            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    d="M5.02994 6.33315L5.77994 6.83315L7.02769 5.16947M9.37326 6.00131H10.7066M5.02994 10.3339L5.77994 10.8339L7.02769 9.17023M7.33464 13.3346H4.0013C3.26492 13.3346 2.66797 12.7377 2.66797 12.0013V4.0013C2.66797 3.26492 3.26492 2.66797 4.0013 2.66797H12.0013C12.7377 2.66797 13.3346 3.26492 13.3346 4.0013V6.66797M12.668 13.3346C12.668 13.7028 12.3695 14.0013 12.0013 14.0013C11.6331 14.0013 11.3346 13.7028 11.3346 13.3346M14.0013 13.3346V11.3346C14.0013 10.2301 13.1059 9.33464 12.0013 9.33464C10.8967 9.33464 10.0013 10.2301 10.0013 11.3346V13.3346H14.0013Z"
                    stroke="#1E293B"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <div
                class="text-slate-800 text-xs font-medium leading-none relative"
            >
                <i
                    v-if="loadingMatches"
                    class="fal fa-spinner-third fa-spin text-slate-500 text-base leading-none absolute -top-0.5 -left-1 z-10"
                ></i>
                {{ matches.length }}
            </div>
        </div>
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useAlertsStore } from '@/store/alerts';
import { ref, onMounted, computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
export default {
    components: {
        Icon,
    },
    props: {
        alert: Object,
    },
    setup(props) {
        const badgeOptions = {
            monitoring: {
                status: 'Active',
                icon: 'radar',
            },
            completed: {
                status: 'Completed',
                icon: 'check',
            },
            expired: {
                status: 'Dates expired',
                icon: 'calendar-check',
            },
            unavailable: {
                status: 'Unavailable',
                icon: 'workspace-block',
            },
            found: {
                status: 'Found', //will change to 'Active', this is for testing
                icon: 'radar',
            },
        };

        const store = useAlertsStore();
        const { loadingMatches } = storeToRefs(store);
        const badge = ref(badgeOptions.monitoring);
        const matches = computed(() => props.alert.matches);

        const updateStatus = () => {
            badge.value = badgeOptions[props.alert.status];
        };

        updateStatus();

        onMounted(() => {
            if (props.alert.status === 'found') {
                store.getMatches(props.alert);
            }
        });

        return { badge, matches, loadingMatches };
    },
};
</script>
